import { useState } from "react";
import CategoryInfo from "../../model/categoryInfo";
import CategoryMenu from "../../model/Category";
import { setCategories } from "../providers/category";

export function useCategory(): [CategoryMenu, Function] {
    const categories : CategoryInfo[] = [];
    const [state, setState] = useState({
        categories: categories,
    });

    return [state, (categories: CategoryInfo[]) => setCategories(setState, categories)];
}
